export default "__VITE_ASSET__e45a8052__"